var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routing-detail"},[_c('div',{staticClass:"title custom-title"},[_vm._v("Routing Details")]),_c('validation-observer',{ref:"validateRouting",attrs:{"name":"Routing"}},[_c('b-card',{staticClass:"b-card-bg"},[_c('b-row',{staticClass:"px-2"},[_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('validation-provider',{attrs:{"name":"Quotation No.","rules":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('b-form-group',[_c('label',[_vm._v("Quotation No.")]),_c('Select4',{staticClass:"select2-v2",class:errors.length > 0 ? 'is-invalid' : null,attrs:{"disabled":_vm.readonly,"placeholder":"Quotation No.","options":{
                  isSearch: true,
                  value: 'id',
                  label: 'id',
                  data: _vm.quotations,
                  fields: [
                    {
                      field: 'id',
                      label: 'Quotation No.',
                    },
                    {
                      field: 'exp_date',
                      label: 'Valid to',
                    },
                    {
                      field: 'total_cost',
                      label: 'Total cost',
                    } ],
                }},model:{value:(_vm.value.quotation),callback:function ($$v) {_vm.$set(_vm.value, "quotation", $$v)},expression:"value.quotation"}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(errors.length > 0),expression:"errors.length > 0"}],staticClass:"text-danger"},[_vm._v(_vm._s(errors[0]))])],1)]}}])})],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('validation-provider',{attrs:{"name":"Transit Port","rules":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var errors = ref.errors;
return [_c('b-form-group',[_c('label',[_vm._v("Transit Port")]),_c('Select4',{staticClass:"select2-v2",class:errors.length > 0 ? 'is-invalid' : null,attrs:{"disabled":_vm.readonly,"placeholder":"Transit Port","options":{
                  isSearch: true,
                  isReload: true,
                  value: 'code',
                  label: 'name',
                  data: _vm.ports,
                  fields: [
                    {
                      field: 'code',
                      label: 'Port code',
                    },
                    {
                      field: 'name',
                      label: 'port name',
                    },
                    {
                      field: 'country_code',
                      label: 'country_code',
                    } ],
                }},on:{"reload":_vm.loadPort},model:{value:(_vm.value.transit_port),callback:function ($$v) {_vm.$set(_vm.value, "transit_port", $$v)},expression:"value.transit_port"}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(errors.length > 0),expression:"errors.length > 0"}],staticClass:"text-danger"},[_vm._v(_vm._s(errors[0]))])],1)]}}])})],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('validation-provider',{key:_vm.reload,attrs:{"name":"Origin Port","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var errors = ref.errors;
return [_c('b-form-group',[_c('label',{staticClass:"flex"},[_vm._v("Origin Port "),_c('span',{staticClass:"red"},[_vm._v("*")])]),_c('Select4',{class:errors.length > 0 ? 'is-invalid' : null,attrs:{"disabled":_vm.readonly,"placeholder":"POL/AOL","options":{
                  isSearch: true,
                  isReload: true,
                  value: 'code',
                  label: 'name',
                  data: _vm.ports,
                  fields: [
                    {
                      field: 'code',
                      label: 'Port code',
                    },
                    {
                      field: 'name',
                      label: 'port name',
                    },
                    {
                      field: 'country_code',
                      label: 'Country',
                    } ],
                }},on:{"reload":_vm.loadPort},model:{value:(_vm.value.pol_port),callback:function ($$v) {_vm.$set(_vm.value, "pol_port", $$v)},expression:"value.pol_port"}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(errors.length > 0),expression:"errors.length > 0"}],staticClass:"text-danger"},[_vm._v(_vm._s(errors[0]))])],1)]}}])})],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('validation-provider',{key:_vm.reload,attrs:{"name":"Delivery Port","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var errors = ref.errors;
return [_c('b-form-group',[_c('label',{staticClass:"flex"},[_vm._v("Delivery Port "),_c('span',{staticClass:"red"},[_vm._v("*")])]),_c('Select4',{class:errors.length > 0 ? 'is-invalid' : null,attrs:{"disabled":_vm.readonly,"placeholder":"POD/AOD","options":{
                  isSearch: true,
                  isReload: true,
                  value: 'code',
                  label: 'name',
                  data: _vm.ports,
                  fields: [
                    {
                      field: 'code',
                      label: 'Port code',
                    },
                    {
                      field: 'name',
                      label: 'Port Name',
                    },
                    {
                      field: 'country_code',
                      label: 'Country',
                    } ],
                }},on:{"reload":_vm.loadPort},model:{value:(_vm.value.pod_port),callback:function ($$v) {_vm.$set(_vm.value, "pod_port", $$v)},expression:"value.pod_port"}}),_c('small',{directives:[{name:"show",rawName:"v-show",value:(errors.length > 0),expression:"errors.length > 0"}],staticClass:"text-danger"},[_vm._v(_vm._s(errors[0]))])],1)]}}])})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }